import React, { useRef, useState, useEffect } from "react";
import {
    Button,
    Chip,
    Grid,
    Accordion,
    AccordionSummary,
    Typography,
    IconButton,
} from "@material-ui/core";
import { ExpandMore, MoreHoriz } from "@material-ui/icons";
import { MdClear } from "react-icons/md";
import { makeStyles } from "@material-ui/core/styles";
import { ValidatorForm } from "react-material-ui-form-validator";
import moment from "moment";
import { searchIcon, crossImg } from "../../../../resources/images";
import { useDebounce } from "../../../../utils/use-debounce";
import {
    FilterArrow,
} from "../../LeftNav/SvgIcons";
import {
    FilterCreationDate,
} from "../EndUser";
import { InputField } from "../../../../components/common";
import { AutoComplete } from "../../../../components/common/FilterLayout/GridFilter";

const ChipItem = ({ chipLabel, chipValue, onDelete }) => {
    const classes = useStyless();

    return (
        <Chip
            className={classes.MuiChip}
            deleteIcon={<MdClear style={{ width: "16px", height: "16px" }} />}
            label={
                <span className={classes.MuiChip}>
                    <b>{chipLabel}: </b>
                    {chipValue}
                </span>
            }
            onDelete={onDelete}
        />
    );
};

const useStyless = makeStyles(theme => ({
    gridWrapper: {
        paddingTop: "29px",
        paddingBottom: "20px",
        borderBottom: "1px solid #E2E6E9",
        position: "relative",
    },
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    MuiChip: {
        backgroundColor: "#CDE5FF",
        color: "#70808F",
        maxWidth: "99%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "left",
        margin: "0px 5px 5px 0px",
        textWrap: "auto",
    },
    chip: {
        margin: 2,
    },
    dropdownBg: {
        background: "#f1f1f1",
    },
    formControl: {
        minWidth: "100%",
        background: "transparent",
    },
    selectEmpty: {
        border: "1px solid #F3F6F9",
        backgroundColor: "#F3F6F9",
        borderRadius: "6px",
        "&:before": {
            borderBottom: "1px solid #F3F6F9",
            "&:hover": {
                borderBottom: "0 !important",
            },
        },
        "&:after": {
            borderBottom: "1px solid #F3F6F9",
        },

        MuiSvgIcon: {
            root: {
                fontSize: 20,
            },
        },
    },
    MuiSelect: {
        icon: {
            fontSize: "26px",
        },
        iconOutlined: {
            fontSize: "26px",
        },
    },
    MuiFilledInput: {
        root: {
            "&:hover": {
                backgroundColor: "#F3F6F9",
            },
        },
    },
    dropdownWrapper: {
        width: "650px",
        padding: "15px 37px 40px 37px",
        position: "fixed",
        boxShadow: "0px 0px 13px 0px #ccc",
        right: "95px",
        marginTop: "-55px",
    },
    autocomplete: {
        "& .MuiAutocomplete-input:first-child": {
            padding: "6px 6px 6px 0px !important"
        }
    },
}));

const platformOptions = [
    // {
    //     id: 0,
    //     name: "Facebook",
    // },
    // {
    //     id: 1,
    //     name: "Instagram",
    // },
    // {
    //     id: 2,
    //     name: "Shopify",
    // },
    {
        id: 3,
        name: "Account-Web",
    },
    {
        id: 4,
        name: "IOS",
    },
    {
        id: 5,
        name: "Android",
    },
];

const ActivityLogsFilter = ({
    AppliedFilters,
    onApplyFilters,
    ActiveTabId,
    setActiveTabId,
    usersList,
    title = `All Activity Logs`,
    setSelectedUser,
    controllers,
    allActions,
}) => {
    const classes = useStyless();

    const [search, setSearchText] = useState("");
    const { debouncedValue: debouncedSearchTxt } = useDebounce(search, 500);
    const [applyFilter, setApplyFilter] = useState(null);

    const [controllerName, setControllerName] = useState("");
    const [actionName, setActionName] = useState("");

    const [start, setStartDate] = useState(null);
    const [end, setEndDate] = useState(null);
    const [userId, setUserId] = useState("");
    const [platform, setPlatform] = useState("");
    const [selectedUserName, setSelectedUserName] = useState("");
    const [isFilter, setIsFilter] = useState(false);

    let filtersIndex = 0;
    const filtersLimit = 6;
    const indexReference = useRef(filtersIndex);
    const [showFilters, setShowFilter] = useState(false);

    useEffect(() => {
        setSearchText(AppliedFilters?.search ?? "");
        setStartDate(AppliedFilters?.start ?? null);
        setEndDate(AppliedFilters?.end ?? null);
        setPlatform(AppliedFilters?.platform ?? "");
        setUserId(AppliedFilters?.userId ?? "");
        setControllerName(AppliedFilters?.controller ?? "");
        setActionName(AppliedFilters?.action ?? "");
        if (AppliedFilters.userId) {
            const userName = usersList.find(x => x.id === userId)?.name ?? "";
            setSelectedUserName(userName);
            setSelectedUser(userName);
        } else {
            setSelectedUserName("");
            setSelectedUser("");
        }
    }, [AppliedFilters]);

    const showFilter = () => {
        window.scroll(0, 0);
        setIsFilter(true);
    };

    const hideFilter = () => {
        setIsFilter(false);
    };

    const applyFilters = () => {
        setApplyFilter(true)
        onApplyFilters(
            {
                search: search,
                start: start ? new Date(start).toISOString() : null,
                end: end ? new Date(end).toISOString() : null,
                userId: userId,
                platform: platform,
                controller: controllerName,
                action: actionName,
            },
            isFilterApplied()
        );
        hideFilter();
    };

    useEffect(() => {
        applyFilters();
    }, [debouncedSearchTxt]);

    const isFilterApplied = () => {
        return (
            start ||
            end ||
            userId ||
            platform
        );
    };

    const filtersCount =
        (start ? 1 : 0) +
        (end ? 1 : 0) +
        (userId ? 1 : 0) +
        (platform ? 1 : 0) +
        (controllerName ? 1 : 0) +
        (actionName ? 1 : 0);

    indexReference.current = filtersIndex;
    const minStartDate = new Date();
    minStartDate.setDate(minStartDate.getDate() - 10);

    useEffect(() => {
        if (!filtersCount) {
            setApplyFilter(false)
        }
    }, [filtersCount]);

    return (
        <div className={classes.gridWrapper}>
            <ValidatorForm ref={useRef("form")} onSubmit={(e) => e.preventDefault()}>
                <Grid container spacing={2}>
                    <Grid
                        item
                        md={12}
                        className='filterMainSearch endUserSearchFilterMain'>
                        <img src={searchIcon} alt='' className='searchIcon' />
                        <InputField
                            placeholder='Search'
                            value={search}
                            onKeyPress={({ key }) => {
                                if (["Enter", "enter"].includes(key)) applyFilters();
                            }}
                            onChange={({ target }) => {
                                setSearchText(target.value);
                            }}
                            onPaste={value => {
                                const splitValue = value.split("\n");
                                setSearchText(splitValue.join(", "));
                            }}
                        />
                        <span className='endUserSearchFilter' onClick={showFilter}>
                            {(["4", "5", "6"].includes(ActiveTabId) && filtersCount > 1 && applyFilter) ||
                                (!["4", "5", "6"].includes(ActiveTabId) && filtersCount > 0 && applyFilter) ? (
                                <span>{`${filtersCount} Filter${filtersCount > 1 ? "(s)" : ""
                                    } Applied `}</span>
                            ) : null}
                            <FilterArrow color={"#fff"} />
                        </span>
                    </Grid>

                    {/* <Grid item md={1} className='blockEndUserBtn'>
                        <span><GridHide /></span>
                        <span><ListShow /></span>
                    </Grid> */}
                </Grid>

                {isFilter && (
                    <div className='endUserFilterWrapper'>
                        <div className='endUserFilterInnerWrapper'>
                            <img
                                className='filterCrossImage'
                                src={crossImg}
                                alt='cross icon'
                                onClick={hideFilter}
                            />
                            <div className='formContainer'>
                                <h3>{title}</h3>
                                <Accordion
                                    defaultExpanded
                                    id='end-user-filter-expandable'
                                    TransitionProps={{ unmountOnExit: true }}>
                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                        <Typography>
                                            <span>Active Filter(s)</span>
                                            <span>
                                                <Button
                                                    className='filterClearBtn'
                                                    variant='outlined'
                                                    onClick={() => {
                                                        onApplyFilters(
                                                            {
                                                                search: "",
                                                                start: null,
                                                                end: null,
                                                                userId: "",
                                                                platform: "",
                                                                controller: "",
                                                                action: "",
                                                            },
                                                            false
                                                        );
                                                        if (ActiveTabId !== "0") setActiveTabId(`${0}`);
                                                        hideFilter();
                                                    }}>
                                                    Clear
                                                </Button>
                                            </span>
                                        </Typography>
                                    </AccordionSummary>
                                    <div>
                                        {filtersCount <= 0 && (
                                            <div className={`filtersChips`}>No Active Filter(s)</div>
                                        )}
                                        {(start || end) && (
                                            <ChipItem
                                                chipLabel='Date'
                                                chipValue={`${start
                                                    ? moment(start).format("MM/DD/yyyy")
                                                    : "?"
                                                    } - ${end ? moment(end).format("MM/DD/yyyy") : "?"
                                                    }`}
                                                onDelete={() => {
                                                    if (start) setStartDate(null);
                                                    if (end) setEndDate(null);
                                                }}
                                            />
                                        )}

                                        {userId && (
                                            <ChipItem
                                                chipLabel='Selected User'
                                                chipValue={`${selectedUserName}`}
                                                onDelete={() => {
                                                    if (userId) {
                                                        setUserId("");
                                                        setSelectedUserName("");
                                                        setSelectedUser("");
                                                    }
                                                }}
                                            />
                                        )}

                                        {platform && (
                                            <ChipItem
                                                chipLabel='Platform'
                                                chipValue={`${platform}`}
                                                onDelete={() => {
                                                    if (platform) setPlatform("");
                                                }}
                                            />
                                        )}
                                        {controllerName && (
                                            <ChipItem
                                                chipLabel='Controller Name'
                                                chipValue={`${controllerName}`}
                                                onDelete={() => {
                                                    if (controllerName) setControllerName("");
                                                }}
                                            />
                                        )}
                                        {actionName && (
                                            <ChipItem
                                                chipLabel='Action Name'
                                                chipValue={`${actionName}`}
                                                onDelete={() => {
                                                    if (actionName) setActionName("");
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            textAlign: "right",
                                        }}>
                                        {filtersCount > filtersLimit && (
                                            <IconButton
                                                color={"primary"}
                                                onClick={() => setShowFilter(!showFilters)}>
                                                <MoreHoriz />
                                            </IconButton>
                                        )}
                                    </div>
                                </Accordion>

                                <h4>Creation Date</h4>
                                <FilterCreationDate
                                    StartDate={start}
                                    setStartDate={(val) => val ? setStartDate(val.setHours(0, 0, 0, 0)) : setStartDate(null)}
                                    minStartDate={minStartDate}
                                    EndDate={end}
                                    setEndDate={(val) => val ? setEndDate(val.setHours(23, 59, 59, 999)) : setEndDate(null)}
                                />
                                <div style={{ marginTop: "10px" }}></div>
                                <div className='userDetailsSearchField inputWrapper filterSelect'>
                                    <AutoComplete
                                        value={platformOptions.find(x => x.name === platform)}
                                        onChange={(event, value) => {
                                            setPlatform(value.name);
                                        }}
                                        id='platform'
                                        options={platformOptions}
                                        getOptionLabel={option => option?.name || ""}
                                        placeholder={"Platform"}
                                    />

                                    <div style={{ marginTop: "5px" }}></div>
                                    <AutoComplete
                                        className={classes.autocomplete}
                                        id='tags-outlined'
                                        value={usersList.find(x => x.id === userId)}
                                        options={usersList}
                                        getOptionLabel={option => option.name}
                                        filterSelectedOptions
                                        onChange={(_event, user) => {
                                            setUserId(user.id);
                                            setSelectedUserName(user.name);
                                            // setSelectedUser(user.name);
                                        }}
                                        placeholder={"User"}
                                    />
                                </div>
                                <div className='userDetailsSearchField inputWrapper filterSelect'>
                                    <AutoComplete
                                        value={controllers.find(x => x === controllerName)}
                                        onChange={(event, value) => {
                                            setControllerName(value);
                                        }}
                                        id='controllers'
                                        options={controllers}
                                        getOptionLabel={option => option || ""}
                                        placeholder={"Controller Name"}
                                    />
                                    <AutoComplete
                                        value={allActions.find(x => x === actionName)}
                                        onChange={(event, value) => {
                                            setActionName(value);
                                        }}
                                        id='actions'
                                        options={allActions}
                                        getOptionLabel={option => option || ""}
                                        placeholder={"Action Name"}
                                    />
                                </div>
                            </div>
                            <div className='endUserfilrerBtn'>
                                <Button
                                    variant='contained'
                                    onClick={() => {
                                        applyFilters();
                                    }}>
                                    Apply Filter
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </ValidatorForm>
        </div>
    );
};

export { ActivityLogsFilter };
